'use strict';

import scrollWatcher from '../watchers/scroll-watcher';

const classNames = {
	backToTopLink: 'back-to-top-link',
	stickyBackToTopContainer: 'sticky-back-to-top-container'
};

export default {
	init() {
		$.findByBem(classNames.backToTopLink).on('click.back-to-top', (e) => {
			e.preventDefault();
			window.scrollTo(0, 0);
		});

		scrollWatcher.onScroll((event) => {
			const $stickyContainer = $.findByBem(classNames.stickyBackToTopContainer);

			if (!event.isAtTop && event.scrollDirection === 'up') {
				$stickyContainer.show();
			} else {
				$stickyContainer.hide();
			}
		});
	}
}